import jwtDecode from 'jwt-decode';

import { parseJson } from '../utils';
import { getSessionItem, getSessionToken, STORAGE_KEYS } from '../auth';

/**
 * Get the default locale from user token, user profile, or browser language
 * @param {string} [payload] User auth token
 * @returns {string} Locale string (e.g., 'es-PE', 'en-US')
 */
export const getDefaultLocale = (payload = {}) => {
  let locale = null;

  try {
    const token = payload ?? getSessionToken();
    locale = jwtDecode(token?.accessToken)?.language;
  } catch (e) {}

  if (!locale) {
    try {
      const user = parseJson(getSessionItem(STORAGE_KEYS.AUTH_USER));
      locale = user?.defaultLanguage ?? user?.company?.language;
    } catch (e) {}

    if (!locale) {
      const userLanguage = (navigator.language || navigator.languages[0])?.toLowerCase();
      const localeMap = {
        es: 'es-PE',
        en: 'en-US',
      };

      const langCode = userLanguage.split('-')[0];
      return localeMap[langCode] || localeMap.en;
    }
  }

  return locale;
};
